import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Accordion from '~/components/ui/Accordion/Accordion';
import TextInput from '~/components/ui/TextInput';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { socialMediaSlice, updateSocialSiteThunk } from '~/store/reducers/previewScreens/social-media';
import { getSocialMediaReducer } from '~/store/reducers/previewScreens/social-media/selectors';
import { isMaxLength } from '~/utils/common';

const linkListForms = [
  {
    label: 'title',
    value: 'Example',
    id: 'head',
    beId: 'title',
    maxLength: 100,
    isRequired: true,
  },
  {
    label: 'description',
    value: 'Example',
    id: 'description',
    beId: 'description',
    maxLength: 200,
  },
];

const { actions } = socialMediaSlice;

export default function BasicInformation() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const handleSendField = (field, value) => {
    dispatch(updateSocialSiteThunk({ [field]: value }));
  };

  const { appInformation } = useSelector(getSocialMediaReducer);

  const isRequired = (isRequired, value) => (isRequired && !value ? t('inputs:required') : null);

  return (
    <CreateQRContentBlockLayout type="basicInfo">
      <Accordion
        defaultExpanded
        variant="child"
        hideBottomBorder
        summary={t('template6:socialmedia')}
        details={
          <>
            {linkListForms.map((item, index) => {
              return (
                <TextInput
                  onChange={(e) => dispatch(actions.setAppInformation({ field: item.id, value: e.target.value }))}
                  onBlur={() => handleSendField(item.beId, appInformation[item.id])}
                  key={item.label + index}
                  sx={{ mb: 2 }}
                  fullWidth
                  placeholder={t('common:typeHere')}
                  label={t(`other:${item.label}`)}
                  defaultValue={appInformation[item.id]}
                  inputProps={{ maxLength: item?.maxLength }}
                  helperText={
                    isRequired(item?.isRequired, appInformation[item.id]) ||
                    isMaxLength(appInformation[item.id], item?.maxLength)
                  }
                  error={isRequired(item?.isRequired, appInformation[item.id])}
                />
              );
            })}
          </>
        }
      />
    </CreateQRContentBlockLayout>
  );
}
